import Component from '@glimmer/component';

import { hash } from '@ember/helper';

import CIdentity from 'rise-ui/components/c-identity.gjs';

export default class ErrorPageComponent extends Component {
  <template>
    <div class="qa-error-page" ...attributes>
      <h3 class="c-page-title qa-page-title">{{yield (hash title=(component CIdentity))}}</h3>
      <div class="c-help">
        <p class="c-help__primary">
          {{yield (hash subtitle=(component CIdentity))}}
        </p>
        <p>
          {{yield (hash content=(component CIdentity))}}
        </p>
      </div>
    </div>
  </template>
}
